module.exports = __webpack_public_path__ + "img/karenroco.d42006ad.jpg";